import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enJSON from './en/en.json';
import huJSON from './hu/hu.json'; 

i18n.use(initReactI18next).init({
    resources: {
      en: { ...enJSON },
      hu: { ...huJSON },
    },
    fallbackLng:"hu",
    lng: "hu",
});

export default i18n;